import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ReportItemProductionCostingService extends GenericService {
    constructor() {
        super('/reports/item_production_costing', axiosInstance);
    }
}

export default new ReportItemProductionCostingService(); 